import { call, put, takeLeading } from 'redux-saga/effects';
import { otAssetActions } from '../reducers/otAsset';
import otAssetGateway from '../api/otAsset';

function* otAssetDataRequest({ payload }: any): any {
  const res = yield call(otAssetGateway.fetchOTAsset, payload);
  if (res.status === 'success') {
    yield put(otAssetActions.getOtAssetDataResponse(res));
  } else {
    yield put(otAssetActions.getOtAssetDataFailed());
  }
}

function* otAssetSaga() {
  yield takeLeading('otAsset/getOtAssetDataRequest', otAssetDataRequest);
}

export default otAssetSaga;
